import { InputHTMLAttributes } from 'react';

import { useField } from 'formik';
import { Box } from '@mui/material';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

type SelectOption = { value: any; text: string };

interface SelectFieldProps {
  name: string;
  label?: string;
  options: SelectOption[];
  selectProps: InputHTMLAttributes<HTMLSelectElement>;
}

export function SelectField({ label, name, selectProps, options }: SelectFieldProps) {
  const [field, meta] = useField(name);
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const showError = meta.touched && Boolean(meta.error);
  return (
    <Box position="relative">
      <label className="s-label" htmlFor={label}>
        {label}
      </label>
      <select
        id={label}
        className={`s-select ${showError ? 'invalid' : ''}`}
        {...field}
        {...selectProps}
      >
        <option disabled>{t('select')}</option>
        {options.map((option: any, i: number) => (
          <option key={i} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>
      <Box
        position="absolute"
        display="flex"
        alignItems="center"
        bottom={0}
        right={0}
        padding={'11px'}
        style={{
          pointerEvents: 'none',
        }}
      >
        <MdKeyboardArrowDown size={24} />
      </Box>
      {showError && <p className="p-FieldError Error">{meta.error}</p>}
    </Box>
  );
}
